import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryQualityInspectionList extends BaseModelAPI {

	static entity = 'newobject1918list'
	static entityName = 'deliveryqualityinspection';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
